const lipFiller = {
  hero: {
    titlePrefix: "Premium",
    titleAccent: "Lip Filler",
    titleSuffix: "Treatments",
    description:
      "Enhance your natural beauty with our safe and effective lip augmentation treatments, designed to give you the perfect, full lips you've always wanted.",
    ctas: {
      primary: "Book Consultation",
      secondary: "Learn About Process",
    },
    imageAlt: "Woman with full, natural-looking lips after filler treatment",
    callout: {
      title: "Natural-Looking Results",
      body:
        "Our lip fillers enhance your natural beauty without an overdone appearance",
    },
  },
  benefits: {
    headingPrefix: "Benefits of",
    headingAccent: "Lip Fillers",
    intro:
      "Discover how our premium lip fillers can enhance your facial aesthetics and boost your confidence.",
    items: [
      {
        title: "Natural Enhancement",
        description:
          "Our fillers enhance your natural lip shape rather than creating an obviously artificial look.",
      },
      {
        title: "Immediate Results",
        description:
          "See visible improvements right after your treatment with minimal downtime.",
      },
      {
        title: "Customizable Volume",
        description:
          "We can add as much or as little volume as you desire to achieve your perfect look.",
      },
      {
        title: "Improved Lip Shape",
        description:
          "Correct asymmetry and define the borders of your lips for a more balanced appearance.",
      },
      {
        title: "Reduced Fine Lines",
        description:
          "Smooth out vertical lip lines and wrinkles around the mouth area.",
      },
      {
        title: "Temporary Results",
        description:
          "Enjoy the flexibility of a non-permanent solution that typically lasts 6-12 months.",
      },
    ],
  },
  process: {
    headingPrefix: "Our",
    headingAccent: "Lip Filler",
    headingSuffix: "Process",
    intro:
      "Our premium lip filler treatments follow a meticulous process to ensure safety, comfort, and beautiful, natural-looking results.",
    steps: [
      {
        title: "Consultation",
        description:
          "Meet with our specialist to discuss your goals and expectations for your lip enhancement.",
      },
      {
        title: "Treatment Planning",
        description:
          "We'll create a personalized treatment plan tailored to your facial features and desired outcome.",
      },
      {
        title: "Preparation",
        description:
          "A topical numbing cream is applied to ensure your comfort during the procedure.",
      },
      {
        title: "Injection",
        description:
          "Our specialist will carefully inject the dermal filler to achieve natural-looking volume and definition.",
      },
      {
        title: "Results",
        description:
          "Enjoy immediate results that will continue to settle beautifully over the next few days.",
      },
    ],
  },
  faq: {
    headingPrefix: "Frequently Asked",
    headingAccent: "Questions",
    intro: "Get answers to common questions about our lip filler treatments.",
    items: [
      {
        question: "How long do lip fillers last?",
        answer:
          "Lip fillers typically last between 6-12 months, depending on the type of filler used and your individual metabolism. Over time, the body naturally breaks down the filler, requiring periodic touch-ups to maintain your desired look.",
      },
      {
        question: "Is the lip filler procedure painful?",
        answer:
          "We apply a topical numbing cream before treatment to minimize discomfort. Most patients report only mild pressure or a slight pinch during injections. Many lip fillers also contain lidocaine, a local anesthetic, to further enhance comfort during the procedure.",
      },
      {
        question: "How soon will I see results after lip fillers?",
        answer:
          "You'll see immediate volume enhancement after your treatment, though there may be some initial swelling. The final results become visible once any swelling subsides, typically within 1-2 weeks after the procedure.",
      },
      {
        question: "What is the recovery time for lip fillers?",
        answer:
          "Most patients can return to their normal activities immediately after treatment. You may experience some swelling, bruising, or tenderness for 2-3 days. We recommend avoiding intense physical activity for 24-48 hours after the procedure.",
      },
      {
        question: "Are lip fillers reversible if I don't like the results?",
        answer:
          "Yes, hyaluronic acid-based fillers (which we use) can be dissolved with an enzyme called hyaluronidase if you're unhappy with the results. This is one of the reasons why these fillers are so popular—they offer the flexibility of reversal.",
      },
      {
        question: "Who is not a good candidate for lip fillers?",
        answer:
          "Individuals who are pregnant, breastfeeding, have certain autoimmune disorders, active cold sores, or allergies to filler ingredients should avoid lip augmentation. During your consultation, we'll review your medical history to ensure lip fillers are safe for you.",
      },
    ],
  },
};

export default lipFiller;

